import { Component, Input } from '@angular/core';

type loadingSizes = 'xs' | 'sm' | 'md' | 'lg';
type configLoading = {diameter: number; stroke: number; fontSize: string};

@Component({
    selector: 'app-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss']
})
export class LoadingComponent {
    private sizes: {[key:string]: [number,number,string]} = {
        xs: [15,2,'11px'],
        sm: [30,4,'14px'],
        md: [45,6,'17px'],
        lg: [60,8,'20px']
    }
    loadingSize: loadingSizes = 'lg';
    configLoading:configLoading = {
        diameter: this.sizes[this.loadingSize][0],
        stroke: this.sizes[this.loadingSize][1],
        fontSize: this.sizes[this.loadingSize][2],
    };

    @Input() set size(size: loadingSizes) {
        this.configLoading = {
            diameter: this.sizes[size][0],
            stroke: this.sizes[size][1],
            fontSize: this.sizes[size][2],
        }
    }

    @Input() disableLabel: boolean = true;

    @Input() color: string = "#FF3333"
    @Input() textColor: string = "#454545"
}
